import React, { useRef, useMemo } from 'react';
import { useViewportScroll, useTransform } from 'framer-motion6';
import useScrollBlock from 'hooks/useScrollBlock';
import { SCREEN_SIZES } from 'style';
import useWindowSize from 'hooks/useWindowSize';
import { HeroBackground, HeroContainer, Curve, Globe } from './styled';
import Mission from './components/Mission';
import Team from './components/Team';
import Sphere from './sphere.gif';

const MISSION_HEIGHT = 620;

const Hero = () => {
  const [blockScroll, allowScroll] = useScrollBlock();
  const globeRef = useRef();

  const { height: windowHeight, width: windowWidth } = useWindowSize();
  const { scrollY } = useViewportScroll();

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  const isLargeDesktop = windowWidth > SCREEN_SIZES.extraLargeDesktop;
  const isMobile = windowWidth < SCREEN_SIZES.tabletLandscape;

  const globeWidth = windowWidth < 1280 ? windowWidth / 2 : 640;
  const globeLeftMargin = isLargeDesktop ? 80 : windowWidth * 0.02;
  const enlargedGlobeScale = windowHeight / globeWidth;

  const y = useTransform(scrollY, [0, 720], [0, 720]);
  const x = useTransform(
    scrollY,
    [0, 600],
    [0, isLargeDesktop ? 310 : (windowWidth - globeWidth) / 2 - globeLeftMargin]
  );

  const scale = useTransform(scrollY, [0, 600], [1, 0.75]);
  const paddingTop = useMemo(() => (windowHeight - MISSION_HEIGHT) / 2, [windowHeight]);

  const initialGlobeAnimation = !isMobile && {
    left: isLargeDesktop ? 'calc(50% - 80px)' : '48%',
    scale: enlargedGlobeScale,
    x: '-50%'
  };

  const globeStyle = !isMobile && {
    y,
    x,
    scale
  };

  const globeAnimation = !isMobile && {
    left: 0,
    x: 0,
    scale: 1,
    transition: { duration: 1.8, times: [0.6, 1] }
  };

  return (
    <>
      <HeroBackground>
        <HeroContainer paddingTop={paddingTop}>
          <Globe
            src={Sphere}
            ref={globeRef}
            initial={initialGlobeAnimation}
            animate={globeAnimation}
            onAnimationStart={() => blockScroll()}
            style={globeStyle}
          />
          <Mission
            windowHeight={windowHeight}
            isMobile={isMobile}
            allowScroll={allowScroll}
          />
          <Team isMobile={isMobile} />
        </HeroContainer>
      </HeroBackground>
      <Curve />
    </>
  );
};

export default Hero;
